export const SHOW_SHOPIFY_TAXONOMY = false;
